<template>
  <b-row class="margin-0">
    <b-col cols="12" class="padding-0 margin-bottom-16">
      <Input
        :label="$lang.submitDelayTime"
        :placeholder="`${$lang.submitDelayTime} (${$lang.minute})`"
        :value="form.startDelay"
        name="startDelay"
        id="startDelay"
        type="text"
        :vuelidateObj="$v.form.startDelay"
        @input="input"
        @focus="resetValidation"
        @blur="checkValidation"
      />
    </b-col>
    <b-col cols="12" class="padding-0 flex-end">
      <Button
        contentClass="justify-content-center"
        variant="filled-complementary"
        :text="$lang.cancel"
        @click="handleClose"
      />
      <Button
        class="margin-right-8"
        contentClass="justify-content-center"
        variant="filled-primary"
        :text="$lang.submit"
        :loading="loading"
        @click="submitStartDelay"
      />
    </b-col>
  </b-row>
</template>

<script>
import inputMixin from "@/mixin/inputMixin.vue";
import { Input, Button } from "@/components/re-design/forms";
import { required, numeric } from "vuelidate/lib/validators";
import { pathOr } from "ramda";
import { generateError, toastAlert } from "@/shared/utils";
import { setStartDelay } from "@/modules/kanoon/services";

export default {
  mixins: [inputMixin],
  components: { Input, Button },
  props: {
    item: {
      type: Object,
      default: null,
    },
  },
  validations() {
    return {
      form: {
        startDelay: { required, numeric },
      },
    };
  },
  data() {
    return {
      form: {
        startDelay: null,
      },
      loading: false,
    };
  },
  methods: {
    pathOr,
    handleClose() {
      this.$emit("handleClose");
    },
    async submitStartDelay() {
      this.$v.$touch();
      if (this.$v.$anyError) return;

      try {
        this.loading = true;
        const centerExecuteCode = pathOr(null, ["code"], this.item);
        const { startDelay } = this.form;
        const response = await setStartDelay(centerExecuteCode, startDelay);
        const { message } = response;
        toastAlert(message);
        this.handleClose();
        this.$emit("reloadList");
      } catch (error) {
        generateError(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
